export const videoMap: Record<string, string> = {
  '1.9': 'Quantum for begginers',
  '1.13': 'Ethics',
  '1.5': 'Quantum algorithms and applications',
  '1.6': 'Solving optimization problems with dynex',

  '1. setup (intro & environment)': 'Intro & Setup',
  '2. python basics': 'Python Basics',
  '3. methods & functions': 'Methods & Functions',
  '4. containers': 'Containers',
  '5. control flow': 'Control Flow',
  '6. more on functions': 'More of Functions',
  '7. tools': 'Tools',
  '8. classes': 'Classes',
  '9. modules': 'Modules',
};
